"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertySelector = createPropertySelector;
const react_1 = __importDefault(require("react"));
const property_1 = require("@promaster-sdk/property");
const checkbox_1 = require("../checkbox");
const textbox_1 = require("../textbox");
const radio_group_1 = require("../radio-group");
const combo_box_1 = require("../combo-box");
const amount_1 = require("../amount");
const AmountPropertySelectorDefault = (0, amount_1.createAmountPropertySelector)({});
const ComboboxPropertySelectorDefault = (0, combo_box_1.createComboboxPropertySelector)({});
const CheckboxPropertySelectorDefault = (0, checkbox_1.createCheckboxPropertySelector)({});
const TextboxPropertySelectorDefault = (0, textbox_1.createTextboxPropertySelector)({});
const RadioGroupPropertySelectorDefault = (0, radio_group_1.createRadioGroupPropertySelector)({});
function createPropertySelector({ AmountPropertySelector = AmountPropertySelectorDefault, ComboboxPropertySelector = ComboboxPropertySelectorDefault, TextboxPropertySelector = TextboxPropertySelectorDefault, RadioGroupPropertySelector = RadioGroupPropertySelectorDefault, CheckboxPropertySelector = CheckboxPropertySelectorDefault }) {
    return function PropertySelector({ selectorType, propertyName, quantity, validationFilter, valueItems, selectedProperties, includeCodes, optionalProperties, onChange, onPropertyFormatChanged, onPropertyFormatCleared, onPropertyFormatSelectorToggled, filterPrettyPrint, propertyFormat, readOnly, locked, translatePropertyValue, translateValueMustBeNumericMessage, translateValueIsRequiredMessage, inputDebounceTime, unitsFormat, units }) {
        function onValueChange(newValue) {
            onChange(newValue
                ? property_1.PropertyValueSet.set(propertyName, newValue, selectedProperties)
                : property_1.PropertyValueSet.removeProperty(propertyName, selectedProperties), propertyName);
        }
        switch (getPropertyType(quantity)) {
            case "text":
                return (react_1.default.createElement(TextboxPropertySelector, { propertyName: propertyName, propertyValueSet: selectedProperties, readOnly: readOnly, onValueChange: onValueChange, debounceTime: inputDebounceTime }));
            case "integer":
                if (selectorType === "RadioGroup") {
                    return (react_1.default.createElement(RadioGroupPropertySelector, { propertyName: propertyName, propertyValueSet: selectedProperties, valueItems: valueItems &&
                            valueItems.map(vi => ({
                                value: vi.value,
                                text: translatePropertyValue(propertyName, (vi.value
                                    ? property_1.PropertyValue.getInteger(vi.value)
                                    : undefined)),
                                sortNo: vi.sort_no,
                                validationFilter: vi.property_filter,
                                image: vi.image
                            })), showCodes: includeCodes, filterPrettyPrint: filterPrettyPrint, onValueChange: onValueChange, readOnly: readOnly, locked: locked }));
                }
                else if (selectorType === "Checkbox") {
                    return (react_1.default.createElement(CheckboxPropertySelector, { propertyName: propertyName, propertyValueSet: selectedProperties, valueItems: valueItems &&
                            valueItems.map(vi => ({
                                value: vi.value,
                                text: translatePropertyValue(propertyName, (vi.value
                                    ? property_1.PropertyValue.getInteger(vi.value)
                                    : undefined)),
                                sortNo: vi.sort_no,
                                validationFilter: vi.property_filter,
                                image: vi.image
                            })), showCodes: includeCodes, filterPrettyPrint: filterPrettyPrint, onValueChange: onValueChange, readOnly: readOnly, locked: locked }));
                }
                else {
                    return (react_1.default.createElement(ComboboxPropertySelector, { sortValidFirst: true, propertyName: propertyName, propertyValueSet: selectedProperties, valueItems: valueItems &&
                            valueItems.map(vi => ({
                                value: vi.value,
                                text: translatePropertyValue(propertyName, (vi.value
                                    ? property_1.PropertyValue.getInteger(vi.value)
                                    : undefined)),
                                sortNo: vi.sort_no,
                                validationFilter: vi.property_filter,
                                image: vi.image
                            })), showCodes: includeCodes, filterPrettyPrint: filterPrettyPrint, onValueChange: onValueChange, readOnly: readOnly, locked: locked }));
                }
            default:
                return (react_1.default.createElement(AmountPropertySelector, { propertyName: propertyName, propertyValueSet: selectedProperties, inputUnit: propertyFormat.unit, inputDecimalCount: propertyFormat.decimalCount, onFormatChanged: (unit, decimalCount) => onPropertyFormatChanged(propertyName, unit, decimalCount), onFormatCleared: () => onPropertyFormatCleared(propertyName), onFormatSelectorToggled: (active) => onPropertyFormatSelectorToggled(propertyName, active), onValueChange: onValueChange, notNumericMessage: translateValueMustBeNumericMessage(), 
                    // If it is optional then use blank required message
                    isRequiredMessage: optionalProperties &&
                        optionalProperties.indexOf(propertyName) !== -1
                        ? ""
                        : translateValueIsRequiredMessage(), validationFilter: validationFilter, filterPrettyPrint: filterPrettyPrint, readOnly: readOnly, debounceTime: inputDebounceTime, unitsFormat: unitsFormat, units: units }));
        }
    };
}
function getPropertyType(quantity) {
    switch (quantity) {
        case "Text":
            return "text";
        case "Discrete":
            return "integer";
        default:
            return "amount";
    }
}
//# sourceMappingURL=default-property-selector-component.js.map